import {
  createOrigamiLink,
  deleteOrigamiLink,
  getStack,
} from '../../graphql/graphql';
import { client } from '../../amplify';

export const tagService = {
  tag,
  untag,
  load,
};

function tag(id, stackId) {
  return client.graphql({
    query: createOrigamiLink,
    variables: { origamiId: id, stackId: stackId },
  });
}

function untag(linkId) {
  return client.graphql({
    query: deleteOrigamiLink,
    variables: { id: linkId },
  });
}

function load(id) {
  return client.graphql({ query: getStack, variables: { id: id } });
}
